const regex = {
  tel: /^\+52[\d\s]{13,}$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CURP: /^[A-Z]{4}[0-9]{6}[HM]{1}[A-Z]{2}[A-Z0-9]{3}[A-Z0-9]{2}$/,
};

if (!localStorage.getItem("target_url")) {
  localStorage.setItem("target_url", window.location.href);
}

document
  .querySelector('.banner__form input[name="tel"]')
  ?.addEventListener("input", (e) => {
    let value = e.target.value?.slice(3).replace(/\D/g, "") ?? "";
    let formatted = "+52 ";

    if (value.startsWith("+52")) {
      value = value.slice(3);
    }

    if (value.length > 0) {
      formatted += value.slice(0, 2);
    }
    if (value.length > 2) {
      formatted += " " + value.slice(2, 6);
    }
    if (value.length > 6) {
      formatted += " " + value.slice(6, 11);
    }
    e.target.value = formatted;
  });
  
const form = document.querySelector(".banner__form form");

form?.addEventListener("submit", async (e) => {
  e.preventDefault();
  const formData = new FormData(form);

  const data = {
    full_name: formData.get("name"),
    curp: formData.get("CURP"),
    phone_number: formData.get("tel").replace(/\+52\s?| /g, ""),
    email: formData.get("email"),
    target_url: localStorage.getItem("target_url"),
  };

  let isFormCorrect = true;

  if (!regex.tel.test(formData.get("tel"))) {
    document
      .querySelector(".invalid-message.tel")
      .parentElement.classList.add("visible");
    isFormCorrect = false;
  } else {
    document
      .querySelector(".invalid-message.tel")
      .parentElement.classList.remove("visible");
  }

  if (!regex.email.test(data.email)) {
    document
      .querySelector(".invalid-message.email")
      .parentElement.classList.add("visible");
    isFormCorrect = false;
  } else {
    document
      .querySelector(".invalid-message.email")
      .parentElement.classList.remove("visible");
  }

  if (!regex.CURP.test(data.curp)) {
    document
      .querySelector(".invalid-message.curp")
      .parentElement.classList.add("visible");
    isFormCorrect = false;
  } else {
    document
      .querySelector(".invalid-message.curp")
      .parentElement.classList.remove("visible");
  }

  if (!isFormCorrect) {
    return;
  }
  try {
    const res = await fetch("https://api.credito-365.mx/api/p/landing_lead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    }

    const resData = await res.json();

    const newslettersOfferData = {
      id: resData?.id,
      created_at: resData?.created_at,
      curp: resData?.curp,
      email: resData?.email,
      full_name: resData?.full_name,
      phone_number: resData?.phone_number,
      site_name: resData?.site_name,
      target_url: resData?.target_url,
      user_id: resData?.user_id,
    };

    const res2 = await fetch(
      `${document.location.origin}/wp-json/newsletter_subscribers/v1/add`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newslettersOfferData),
      }
    );

    if (!res2.ok) {
      throw res;
    }

    const element = document.querySelector('.banner__form')

    element.style.height = `${element.offsetHeight}px`;

    element.classList.add("success");

    form.reset();

    setTimeout(() => {
      element.classList.remove("success");
      location.href =
        "https://plataprestamos.mx/?utm_source=prestamosconfiables&utm_medium=send-form";
    }, 2000);
  } catch (e) {
    alert("Algo salió mal");
  }

  return;
});